import { Text } from "@/elements/Text"

interface InputLabelProps {
  label: string
}

export const InputLabel: React.FC<InputLabelProps> = ({ label }) => {
  return (
    <div className="pb-2">
      <Text variant="label">{label}</Text>
    </div>
  )
}
